export default __webpack_public_path__ + "static/media/11.e3d17c0c.png";